// ============================================================================
// QuoteMakerWrittenNotices: "QuoteMaker wrote the quote for <job>" with Review
// it, for a job other than the one on screen (use-quotemaker-written-notices.ts).
// Review it opens the job, and the Assistant brings QuoteMaker's review
// forward there. A notice stays until it is used or closed.
// ============================================================================
import React from 'react';
import { Icons } from '../ui/Icon';
import type { QuoteMakerWrittenRun } from '../../services/quote-brain-runs';

export function quoteMakerWrittenNoticeText(notice: QuoteMakerWrittenRun): string {
    const job = notice.title.trim() || 'a job';
    return notice.delivery === 'held'
        ? `QuoteMaker wrote a new version of the quote for ${job}. Review it to keep yours or use the new one.`
        : `QuoteMaker wrote the quote for ${job}. Review it before you send it.`;
}

export default function QuoteMakerWrittenNotices({ notices, onReview, onDismiss }: {
    notices: QuoteMakerWrittenRun[];
    onReview: (notice: QuoteMakerWrittenRun) => void;
    onDismiss: (runId: string) => void;
}) {
    if (!notices.length) return null;
    return (
        <div className="qm-written-notices" role="region" aria-label="Quotes QuoteMaker wrote">
            {notices.map((notice) => (
                <div key={notice.runId} className="qm-project-update-notice qm-written-notice" role="status" data-testid="quotemaker-written-notice">
                    <span className="qm-project-update-notice__signal" aria-hidden="true">
                        <Icons.CheckCircle size={16} />
                    </span>
                    <div className="qm-project-update-notice__copy">
                        <span>{quoteMakerWrittenNoticeText(notice)}</span>
                    </div>
                    <div className="qm-project-update-notice__actions">
                        <button
                            type="button"
                            className="qm-project-update-notice__action"
                            onClick={() => { onDismiss(notice.runId); onReview(notice); }}
                        >
                            Review it
                        </button>
                    </div>
                    <button
                        type="button"
                        className="qm-project-update-notice__dismiss"
                        onClick={() => onDismiss(notice.runId)}
                        aria-label="Close this notice"
                        title="Close this notice"
                    >
                        <Icons.X size={14} aria-hidden="true" />
                    </button>
                </div>
            ))}
        </div>
    );
}
